/*
 * Point d'entrée pour la page principale de l'extension Excel.
 */

import React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";

const TITLE = "IA pour Excel";
const rootElement = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/**
 * Initialise l'application après que l'environnement Office soit prêt.
 * La méthode `Office.onReady` garantit que l'application est chargée dans le contexte d'Office.
 */
Office.onReady(() => {
  root?.render(<App title={TITLE} />);
});

/**
 * Active le rechargement à chaud (Hot Module Replacement) pour le développement.
 * Cela permet de recharger les modifications du composant `App` sans redémarrer l'application.
 */
if ((module as any)?.hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(<NextApp title={TITLE} />);
  });
}
